module.exports = __webpack_public_path__ + "img/tishi.0327a2a0.png";